import { classNames } from '../../Helpers'

export default function AvatarImage({ url, size = 24, className, ring = true, round = true }) {
    return (
        <img
            className={classNames(
                ring === true ? 'ring-4 ring-white' : '',
                round === true ? 'rounded-full' : '',
                `h-${size} w-${size}`,
                className
            )}
            src={url}
            alt=""
        />
    )
}